import { Piece, PieceAction } from '@rdTypes/apiContract';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type MailpieceActionState = {
  currentAction: PieceAction | null;
  currentMailpiece: Piece | null;
  pendingSearchValue?: string;
  forceActionsDrawer: {
    open: boolean;
    pieces: Piece[];
    pendingSearchValue?: string;
  };
};

const initialState: MailpieceActionState = {
  currentAction: null,
  currentMailpiece: null,
  pendingSearchValue: undefined,
  forceActionsDrawer: {
    open: false,
    pieces: [],
    pendingSearchValue: undefined,
  },
};

const mailpieceActionSlice = createSlice({
  name: 'mailpieceAction',
  initialState,
  reducers: {
    startAction: (
      state,
      { payload }: PayloadAction<{ action: PieceAction; mailpiece: Piece; pendingSearchValue?: string }>,
    ) => {
      state.currentAction = payload.action;
      state.currentMailpiece = payload.mailpiece;
      state.pendingSearchValue = payload.pendingSearchValue;
    },
    resetAction: (state) => {
      state.currentAction = null;
      state.currentMailpiece = null;
      state.pendingSearchValue = undefined;
    },
    openForceActionsDrawer: (state, { payload }: PayloadAction<{ pieces: Piece[]; pendingSearchValue?: string }>) => {
      state.forceActionsDrawer.open = true;
      state.forceActionsDrawer.pieces = payload.pieces;
      state.forceActionsDrawer.pendingSearchValue = payload.pendingSearchValue;
    },
    closeForceActionsDrawer: (state) => {
      state.forceActionsDrawer.open = false;
      state.forceActionsDrawer.pieces = [];
      state.forceActionsDrawer.pendingSearchValue = undefined;
    },
  },
});

export const { startAction, resetAction, openForceActionsDrawer, closeForceActionsDrawer } =
  mailpieceActionSlice.actions;

export default mailpieceActionSlice.reducer;
